import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ViewExcel from './page/viewExcell';
import "./home.css";
import Home from './page/Home';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/view-excel/:id" element={<ViewExcel />} />
          {/* <Route path="/print-invoice" element={<PrintInvoice />} /> */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
